import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

import "./SignupPage.styled";
import IraqSignupPageDisplay from "./SignupPage.styled";
import bgSliders from "../../../helpers/bgSliders";
import games from "./../../../assets/images/logos/gamezone/games.png";
import navLogo from "./../../../assets/images/logos/gamezone/GAMEZONES.png";
import { Trans, withTranslation } from "react-i18next";
import queryString from "query-string";


const randomBg = bgSliders.getRandomBg();

function GameZonePage({ t, i18n }){
    const history = useHistory();

  const language = i18n.language;
 const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    
    // Optional: Update URL without reload
    const newUrl = `${window.location.pathname}?lang=${lng}`;
    window.history.pushState({}, '', newUrl);
  };
const [isAntifraudDone, setIsAntifraudDone] = useState(false);

  const [loaded, setLoaded] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
const [phone, setPhone] = useState("");
const [otp, setOtp] = useState("");
const [showOtp, setShowOtp] = useState(false);
const [loading, setLoading] = useState(false);
const [error, setError] = useState("");
const SUBSCRIBE_URL ="https://vas2.grand-hub.com/api/PlayIt/iraq-dzl-dz/subscribe";

const VERIFY_OTP_URL ="https://vas2.grand-hub.com/api/PlayIt/iraq-dzl-dz/verify";
const ANTIFRAUD_URL = "https://vas2.grand-hub.com/api/PlayIt/iraq-dzl-dz/antifraud";
  useEffect(() => {
     const params = queryString.parse(window.location.search);
    if (params.lang) {
      localStorage.setItem("i18nextLng", params.lang);
      if(localStorage.getItem("i18nextLng") != params.lang){
        localStorage.setItem("i18nextLng", params.lang);
        window.location.reload();
      }
     
    }

    setLoaded(true);
  }, []);

 

const handleSubscribeClick = async (e) => {
  e.preventDefault();
  setError("");

  if (!phone) {
    setError("من فضلك أدخل رقم الموبايل");
    return;
  }

  try {
    setLoading(true);

    // 1️⃣ Call antifraud
    const antiRes = await fetch(ANTIFRAUD_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ phone }),
    });

    const antiData = await antiRes.json();
    console.log("Antifraud response:", antiData);

    localStorage.setItem("subId", antiData.transactionId);

    // 2️⃣ Inject script
    const addScript = document.createElement("script");
    addScript.innerHTML = antiData.data.script;
    document.head.appendChild(addScript);
  var event = new Event('DCBProtectRun');
           document.dispatchEvent(event);
    // 3️⃣ Disable subscribe button
    setIsAntifraudDone(true);

    // 4️⃣ Wait 5 seconds
    await new Promise((resolve) => setTimeout(resolve, 5000));

    // 5️⃣ Call subscribe API
    const res = await fetch(SUBSCRIBE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phone,
        transactionId: antiData.transactionId,
      }),
    });

    const data = await res.json();

    if (data.success) {
      setShowOtp(true);
      localStorage.setItem("transaction", data.transactionId);
    } else {
      setError(data.message || "فشل الاشتراك");
      setIsAntifraudDone(false);
    }

  } catch (err) {
    console.error(err);
    setError("حدث خطأ، حاول مرة أخرى");
    setIsAntifraudDone(false);
  } finally {
    setLoading(false);
  }
};

const handleVerifyOtp = async (e) => {
  e.preventDefault();
  setError("");

  if (!otp) {
    setError("من فضلك أدخل كود التحقق");
    return;
  }

  try {
    setLoading(true);

    const res = await fetch(VERIFY_OTP_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phone: phone,
        otp: otp,
        transactionId: localStorage.getItem("transaction"),
        subId: localStorage.getItem("subId"),
      }),
    });

    const data = await res.json();

    if (data.success) {
      
                     history.push("/login")

    } else {
      setError(data.message || "كود التحقق غير صحيح");
    }
  } catch (err) {
    setError("حدث خطأ أثناء التحقق");
  } finally {
    setLoading(false);
  }
};

  const smoothScroll = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });

    }
  };

  return (
    <IraqSignupPageDisplay>

  <div className={loaded ? "loaded" : ""}>
    <a
      href="#"
      id="EvinaTrapLink"
      style={{ display: "none" }}
    >
      CONFIRMER - OK - VALIDER - BUY - SUBSCRIBE
    </a>

    <div id="loader-wrapper">
      <div id="loader" />
      <div className="loader-section section-left" />
      <div className="loader-section section-right" />
    </div>

    {/* HEADER */}
    <section className="tm-section-head" id="top">
      <div className="container">
        <header id="header" className="tm-text-gray" style={{ textAlign: "center" }}>
          <img src={navLogo} alt="Gamezone" />
        </header>
      </div>
    </section>

    <section className="tm-section-2 tm-section-mb">
      <div className="container">

        {/* LANGUAGE SWITCH */}
       <div style={{ textAlign: "center" }}>
  <button
    className="alang"
    type="button"
    onClick={() =>
      changeLanguage(language === "ar" ? "en" : "ar")
    }
  >
    <p style={{ fontSize: 15 }}>
      {language === "ar" ? "English" : "العربية"}
    </p>
  </button>
</div>


        {/* IMAGE */}
        <div className="text-center">
          <img src={games} alt="games" style={{ width: "70%" }} />
        </div>

        {/* SUBSCRIBE / OTP */}
        <div id="subscribe-button2" className="text-center">

          {!showOtp && (
            <>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder={t("enterPhone")}
                style={{ padding: 10, width: "80%", marginBottom: 10 }}
              />

              <br />

              <button
              id="sub_but"
  className="my-btn"
  onClick={handleSubscribeClick}
  disabled={loading || isAntifraudDone}
>
  {loading ? t("sending") : t("subscribe")}
</button>

            </>
          )}

          {showOtp && (
            <>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder={t("enterOtp")}
                style={{ padding: 10, width: "80%", marginBottom: 10 }}
              />

              <br />

              <button   id="sub_but" className="my-btn" onClick={handleVerifyOtp}>
                {loading ? t("verifying") : t("verify")}
              </button>
            </>
          )}

          {error && (
            <p style={{ color: "red", marginTop: 10 }}>
              {t(error)}
            </p>
          )}
        </div>

        {/* STATS */}
        <div className="row text-center">
          <div className="col-4 px-5">
            <div className="games-info">
              <span>98%</span>
              <img src="/assets/images/subscribegamezriod/like.png" />
              <p>{t("evaluation")}</p>
            </div>
          </div>

          <div className="col-4 px-5">
            <div className="games-info">
              <span>1000+</span>
              <img src="/assets/images/subscribegamezriod/Repeat.png" />
              <p>{t("game")}</p>
            </div>
          </div>

          <div className="col-4 px-5">
            <div className="games-info">
              <span>500k+</span>
              <img src="/assets/images/subscribegamezriod/group.png" />
              <p>{t("user")}</p>
            </div>
          </div>
        </div>

        <br />

        {/* TERMS */}
        <div
          className="text-center"
          style={{
            fontSize: 14,
            fontWeight: "bold"
          }}
        >
          <p>{t("freeDay")}  </p>
          <p>{t("priceIraq")}</p>
          <p>{t("cancel")}</p>
          <p>{t("support")}</p>
        </div>

      </div>
    </section>
  </div>
</IraqSignupPageDisplay>

  );
}
export default withTranslation()(GameZonePage);


